import { useBrandDetails } from 'dw-au-react-components';
import React from 'react';
import { Link } from 'react-router-dom';

function CardLayout({ linkUrl, icon: Icon = '', heading, content }) {
	const brandData = useBrandDetails();
	return (
		<Link to={linkUrl} className='card' title={heading}>
			{Icon && (
				<Icon
					className='mb-12'
					fill={brandData.tag === 'vir' ? '#512698' : '#323232'}
				/>
			)}
			{heading && (
				<h6
					className={`font-oswald lower mb-12 ${
						brandData.tag === 'vir' ? 'text-purple-2' : ''
					}`}
				>
					{heading}
				</h6>
			)}
			{content && <p className='mb-0'>{content}</p>}
		</Link>
	);
}

export default CardLayout;
